import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import { cn } from "@omni/utils/styles";
import React from "react";

export type CardHeaderComponentProps = {};

export type CardHeaderProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, CardHeaderComponentProps, "div">;

const CardHeader = <T extends React.ElementType = "div">({
    className,
    tag,
    ...attributes
}: CardHeaderProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const classes = cn(className, "card-header");

    return (
        <Tag
            {...attributes}
            className={classes}
        />
    );
};

export { CardHeader };
